// Core component styles
const coreStyles={content:{}};/**
 * Combines coreStyles and contextStyles
 * @param {Object} contextStyles
 */const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{content:{...coreStyles.content,...contextStyles.content}};};export default getStyles;